import Vue from 'vue'
import vueRouter from 'vue-router';
import App from './App.vue'
import axios from 'axios';
import BlockUI from 'vue-blockui';
import VueToast from 'vue-toast-notification';
import VueHead from 'vue-head';
import VueLazyload from 'vue-lazyload'
// import CKEditor from '@ckeditor/ckeditor5-vue';
import CKEditor from 'ckeditor4-vue';
import VueAxios from 'vue-axios';
import 'vue-toast-notification/dist/index.css';
import Clipboard from "v-clipboard";
//import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import { store } from './store/store';
import { routes } from './routes';
import { formatDateTime } from '@/utils/globalMethods';



//import * as VueGoogleMaps from 'vue2-google-maps';
//import { ServerTable, ClientTable, Event } from 'vue-tables-2';

Vue.use(VueHead)
Vue.use(vueRouter);
Vue.use(BlockUI);
Vue.use(VueToast);
Vue.use(CKEditor);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment-jalaali'));
//Vue.use(require('vue-moment'));
Vue.use(Clipboard);
Vue.use(VueLazyload);
Vue.prototype.$formatDateTime = formatDateTime;
//Vue.use(ClientTable, {}, false, 'bootstrap4');
/*Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAngQSqA8MZzSohyLW4KdLOjUhIMGEoN0Q',
        libraries: 'places',
    },
})*/
// Vue.use(VuePersianDatetimePicker, {
//     name: 'custom-date-picker',
//     props: {
//         inputFormat: 'YYYY-MM-DD HH:mm',
//         format: "HH:mm",
//         editable: false,
//         inputClass: 'form-control my-custom-class-name',
//         placeholder: 'انتخاب نمایید',
//         altFormat: 'YYYY-MM-DD HH:mm',
//         color: '#00acc1',
//         autoSubmit: true,
//     }
// });



Vue.config.productionTip = false;

const router = new vueRouter({
    routes,
    mode: 'history'
});


axios.defaults.baseURL = 'http://192.168.8.4:3269';
// axios.defaults.baseURL = 'http://192.168.1.236:3269';
// axios.defaults.baseURL = 'https://asankharidiranian.ir';
// axios.defaults.baseURL = 'https://server.arakcarpethall.ir';

//axios.defaults.headers.common['Content-Type']="application/json";
//axios.defaults.headers.common['Access-Control-Allow-Origin']="*";
//axios.defaults.headers.common["Authorization"] = localStorage.getItem("Token");
axios.defaults.headers.get['Accepts'] = "application/json";


axios.interceptors.request.use(config => {
    //console.log(config);
    return config;
});



new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
